import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import DataTable from "react-data-table-component";
import { formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";
import CuponesService from "../../../services/consultas/cuponesService";
import { trackPromise } from "react-promise-tracker";

const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true,
};

export default class Cupones extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaCupones: [],
      cantidad: 0,
      textoInformativo: "",
    };
  }
  componentDidMount() {
    this.getListaCupones();
  }

  getListaCupones() {
    var respuesta = [];
    trackPromise(
      CuponesService.cupones().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigo === "0") {
          if(jData.resultados !== null){
            for (var i = 0; i < jData.resultados.length; i++) {
              var item = jData.resultados[i];
              respuesta.push({
                modalidad: item.modalidad,
                cantidad: formatoSeparadorMilesValue(item.cantidad),
                desde: formatoSeparadorMilesValue(item.nroCuponDesde),
                hasta: formatoSeparadorMilesValue(item.nroCuponHasta),
              });
            }
          }
          this.setState({
            cantidad: jData.cantidadResultados,
            textoInformativo: jData.textoInformativo,
            listaCupones: respuesta,
          });
        }
      })
    );
  }

  getColumn() {
    return [
      {
        name: "Modalidad",
        selector: row => row.modalidad,
        width: "200px",
      },
      {
        name: "Cantidad",
        selector: row => row.cantidad,
        right: true,
      },
      {
        name: "Nro. Cupón Desde",
        selector: row => row.desde,
        right: true,
      },
      {
        name: "Nro. Cupón Hasta",
        selector: row => row.hasta,
        right: true,
      },
    ];
  }

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Cupones Generados" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header"> 
                  {this.state.cantidad > 0 && 
                  <small>{this.state.cantidad} Cupones Generados</small>
                  }
                    
                  
                    
                    <h6>{this.state.textoInformativo}</h6>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="table-responsive">
                          <DataTable
                            noHeader={true}
                            pagination={true}
                            columns={this.getColumn()}
                            data={this.state.listaCupones}
                            dense={true}
                            pagination={true}
                            paginationComponentOptions={paginationOptions}
                            noDataComponent="No hay registros para mostrar"
                            striped={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
